<h1 mat-dialog-title>Select Evaluations:</h1>
<div mat-dialog-content>
    <mat-dialog-content>
        <div class="option-section">
            <div class="section-title">Included Samples</div>
            <div class="included-sample-wrapper">
                <div class="sample-label">
                    <mat-icon matListIcon svgIcon="common:plant_sample"></mat-icon>
                    Plant Samples
                </div>
                <div class="sample-actions">
                    <button mat-icon-button matTooltip="Remove All Samples"
                        (click)="sampleAction(SampleType.PLANT, false)" aria-label="Remove all plant sample evaluations">
                        <mat-icon color="warn">remove_circle_outline</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Add All Samples"
                        (click)="sampleAction(SampleType.PLANT, true)" aria-label="Add all plant sample evaluations">
                        <mat-icon color="primary">add_circle_outline</mat-icon>
                    </button>
                </div>
            </div>
            <div class="included-sample-wrapper">
                <div class="sample-label">
                    <mat-icon matListIcon svgIcon="common:harvest_sample"></mat-icon>
                    Harvest Samples
                </div>
                <div class="sample-actions">
                    <button mat-icon-button matTooltip="Remove All Samples"
                        (click)="sampleAction(SampleType.HARVEST, false)" aria-label="Remove all harvest sample evaluations">
                        <mat-icon color="warn">remove_circle_outline</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Add All Samples"
                        (click)="sampleAction(SampleType.HARVEST, true)" aria-label="Add all harvest sample evaluations">
                        <mat-icon color="primary">add_circle_outline</mat-icon>
                    </button>
                </div>
            </div>
            <mat-form-field appearance="outline" class="eval-search-field">
                <mat-icon matPrefix>search</mat-icon>
                <input type="text" matInput [formControl]="evalSearchControl" placeholder="Search evaluations">
                <button mat-icon-button matSuffix *ngIf="evalSearchControl.value" (click)="clearSearch()"
                    matTooltip="Clear Search" aria-label="Clear search">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <mat-selection-list dense [formControl]="includeEvaluationControl">
            <!-- filtered items are CSS-hidden, not removed: destroying a selected mat-list-option deselects it -->
            <div *ngFor="let sample of samples" [class.filtered-out]="!visibleEvals(sample).length">
                <div mat-subheader>
                    <mat-icon class="mat-18" [svgIcon]="'common:' + sample.data.type + '_sample'">
                    </mat-icon>
                    <span matLine>{{sample.data.label}}</span>&nbsp;
                    <span matLine>({{sample.data.code}})</span>
                </div>
                <mat-list-option *ngFor="let eval of sample.data?.evals" [value]="eval.key"
                    [class.filtered-out]="!matchesFilter(eval)" [disabled]="!matchesFilter(eval)">
                    <span matLine>{{eval.label}}</span>
                    <span matLine>{{eval.evalStartDate}} - {{eval.evalEndDate ? eval.evalEndDate : "N/A"}}</span>
                </mat-list-option>
            </div>
        </mat-selection-list>
        <div class="no-results" *ngIf="evalSearchControl.value && !hasVisibleEvals()">
            No evaluations match "{{evalSearchControl.value}}"
        </div>
    </mat-dialog-content>
</div>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" (click)="attempt()">Save</button>
</mat-dialog-actions>